// 发放员工dlg组件

const myUserDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    dlgType: '',

    list: [],

    code: ""
  },

  getters: {
    dlgShow: state => state.dlgShow,

    dlgType: state => state.dlgType,

    list: state => state.list,

    code: state => state.code
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_DLGTYPE: (state, val) => {
      state.dlgType = val
    },

    SET_LIST: (state, val) => {
      state.list = val
    },

    SET_CODE: (state, val) => {
      state.code = val
    },
  },

  actions: {

  }
}

export default myUserDlg
